import template from "./booking.html";
import {create} from '@/refference.helper';

const illegalCharacters = [9, 16, 17, 18, 20, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 91, 112, 113, 114, 115, 116,
	117, 118, 119, 120, 121, 122, 123, 144, 225];

class controller {
	constructor($bookings,
	            $translates,
	            $rootScope,
	            $uibModal,
	            $scope,
	            $companies,
	            $timeout) {

		'ngInject';

		this.$bookings = $bookings;
		this.target = 'working';
		this.$rootScope = $rootScope;
		this.$uibModal = $uibModal;
		this.$scope = $scope;
		this.$companies = $companies;
		this.$timeout = $timeout;

		this.datePicker = {
			date: {
				startDate: angular.copy(window.moment().subtract(5, "days")),
				endDate: angular.copy(window.moment().endOf('day'))
			}
		};

		this.datePickerOld = angular.copy(this.datePicker);

		this.language = $translates.getLanguage();
		this.isProgress = false;

		this.$onScrollDown();

		this.filters = {
			search: null,
			filter: {
				is_value_relevant: 1,
				company: null,
				payment_status: null,
				"departure_date <= ": window.moment(this.datePicker.date.endDate).format(),
				"departure_date >= ": window.moment(this.datePicker.date.startDate).format(),
			}
		};

		this.paymentStatuses = ["none", "partial", "full"];

		this._timeout = null;

		$bookings.init('/api/all-bookings', this.filters).then(() => {
			this.ready = true;
			this.bookings = this.$bookings.collections.bookings;
		}).then(() => this.$getCustomers());

	}

	$onChange() {

		this.$bookings
			.$search('/api/all-bookings', this.filters)
			.then(bookings => this.bookings = bookings.objects);

	}

	$getCustomers($event, $select) {

		let search = null;

		const $query = () => this.$companies
				.$search("/api/companies", {search: search ? search : null})
				.then(customers => this.customers = customers.objects);

		if(!$event && !$select){
			return $query();
		}


		if (illegalCharacters.indexOf($event.which) !== -1) {
			return false;
		}

		if (this._timeout) {
			this.$timeout.cancel(this._timeout);
		}

		this._timeout = this.$timeout(() => {
			search = $select.searchInput.val();
			$query();
			this._timeout = null;
		}, 300);

	}

	getDate(departure_date) {
		return window.moment(departure_date).format("YYYY-MM-DD HH:mm");
	}

	isEmpty() {
		return this.bookings.filter(booking => this.show(booking)).length;
	}

	status(status) {
		return [0, 1, 10].indexOf(status);
	}

	getNew() {
		return this.bookings.filter(book => this.status(book.booking_status) === -1).length
	}

	show(booking) {
		let target = this.target;
		return (
			(target === 'history' && this.status(booking.booking_status) != -1) ||
			(target === 'working' && this.status(booking.booking_status) === -1)
		);
	}

	$onUpdate(booking) {
		this.$uibModal.open({
			component: 'booking-update',
			resolve: {
				items: function () {
					return {
						booking: booking,
						isAdmin: 'admin'
					}
				}
			}
		});
	}

	$onDelete(booking) {

		this.$uibModal
			.open({
				component: 'destroy',
				size: 'sm',
				windowClass: 'danger',
			})
			.result.then(result => {
			if (result === 'confirm') {
				booking.booking_status = 1;
				this.$bookings.update(booking);
			}
		});
	}

	$onChangeRangePicker() {
		try {
			if (!angular.equals(this.datePicker, this.datePickerOld)) {
				this.datePickerOld = angular.copy(this.datePicker);
				this.filters.filter["departure_date <= "] = window.moment(this.datePicker.date.endDate).format();
				this.filters.filter["departure_date >= "] = window.moment(this.datePicker.date.startDate).format();
				this.$onChange()
			}
		} catch (e) {
			console.log(e);
		}
	}

	$onInit() {
		this.$rootScope.$on('$bookingsUnshift', (e, data) => {
			this.$rootScope.$apply(() => {
				if (data.length > 0) {
					for (let i = 0; i < data.length; i++) {
						this.bookings.unshift(data[i]);
						this.setTemplate(this.bookings[i]);
					}
				}
			});
		});
		this.$rootScope.$on('$bookingsUpdate', (e, data) => {
			this.$rootScope.$apply(() => {
				this.bookings.map((book, iterator) => {
					if (book.uri === data.uri) {
						data.payload.onPush = true;
						this.bookings[iterator] = data.payload;
						this.setTemplate(this.bookings[iterator]);
					}
				});
			});
		});
		this.setTemplate();
	}

	$refreshBooking(booking) {
		booking.$refresh = true;
		this.$bookings.activeGet(booking.uri)
			.then(_booking => {
				this.bookings.map((book, iterator) => {
					if (book.uri === _booking.uri) this.bookings[iterator] = _booking;
				});
			});
	}

	$onScrollDown() {
		this.$scope.$watch('bookingList.waypoints.name.down', (n, o) => {
			if (n && n !== o) {
				try {
					this.loading = true;
					this.$bookings.getBookings(true, '/api/all-bookings').then(() => this.loading = false);
				} catch (e) {
					this.loading = false;
				}
			}
		});
	}

	setTemplate(booking) {

		if (!this.bookings) {
			return false;
		}

		let setBookingExtraInfo = function (booking) {
			if (booking.booking_status == 10 && booking.extra_info !== '') {
				let extraInfo = JSON.parse(booking.extra_info),
					driverList = '',
					consignmentList = `<table class="table table-condensed"><thead><tr><th style="width: 160px">Nazwa</th><th>Ilość</th><th>Waga</th><th>ADR</th></tr></thead><tbody>`;

				if (extraInfo) {
					each(extraInfo.driver, driver => driverList = `${driverList}&nbsp;&nbsp;${driver.name}<br>`);
					each(extraInfo.consignment, consignment => consignmentList = `${consignmentList}<tr><td>${consignment.desc}</td><td>${consignment.qty}</td><td>${consignment.weight}</td><td>${consignment.imo ? 'TAK' : 'NIE'}</td></tr>`);
					consignmentList = `${consignmentList}</tbody></table>`;
				} else {
					driverList = `${driverList}&nbsp;&nbsp;Brak danych<br>`;
					consignmentList = '&nbsp;&nbsp;Brak danych<br>';
				}

				Object.assign(booking, {
					template: `
          <h3>Kierowcy:</h3>
          <p>${driverList}</p>
          <h3>Ładunek:</h3>${consignmentList}
        `
				})
			}
		};
		booking ? setBookingExtraInfo(booking) : this.bookings.map(booking => setBookingExtraInfo(booking));
	}
}

export const adminBookingComponent = {template, controller};


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/booking/booking.component.js
 **/